var _path, _path2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconSend(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 72,
    viewBox: "0 0 72 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M48.6891 18.0859C51.7254 17.2184 54.5325 20.0255 53.665 23.0618L45.999 49.8926C44.7212 54.3649 38.7471 55.205 36.2854 51.2585L30.9237 42.6627C30.4597 41.919 29.8319 41.2911 29.0881 40.8272L20.4923 35.4655C16.5458 33.0038 17.3859 27.0297 21.8583 25.7518L48.6891 18.0859ZM49.8431 21.767C49.8235 21.7615 49.7938 21.757 49.7422 21.7717L22.9114 29.4377C21.6336 29.8028 21.3935 31.5097 22.5211 32.213L31.1169 37.5747C32.3565 38.3479 33.4029 39.3944 34.1761 40.634L39.5379 49.2298C40.2412 50.3573 41.9481 50.1173 42.3132 48.8395L49.9791 22.0087C49.9939 21.957 49.9893 21.9274 49.9839 21.9078C49.9767 21.8821 49.9601 21.8502 49.9304 21.8205C49.9007 21.7908 49.8687 21.7741 49.8431 21.767Z",
    fill: "url(#paint0_linear_0_914)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M40.667 31.0838C41.4156 31.8323 41.4156 33.0458 40.667 33.7944L33.8906 40.5708C33.1421 41.3193 31.9285 41.3193 31.18 40.5708C30.4315 39.8223 30.4315 38.6087 31.18 37.8602L37.9565 31.0838C38.705 30.3353 39.9185 30.3353 40.667 31.0838Z",
    fill: "url(#paint1_linear_0_914)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_0_914",
    x1: 50.5776,
    y1: 53.7865,
    x2: 18.3943,
    y2: 50.273,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F0BA47"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.677095,
    stopColor: "#F3D25C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_0_914",
    x1: 40.2677,
    y1: 41.1322,
    x2: 30.7459,
    y2: 40.0927,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F0BA47"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.677095,
    stopColor: "#F3D25C"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSend);
export default __webpack_public_path__ + "static/media/icon_send.d1b939b299c9611837569af960fef902.svg";
export { ForwardRef as ReactComponent };